<template>
  <div class="input-group" :class="`input-group-${variant} ${getStatus(error, success)}`">
    <label :class="[
      variant === 'static' ? '' : 'form-label',
      color === 'dark' ? 'text-black' : 'text-white'
    ]">{{ label }}</label>
    
    <div class="input-wrapper position-relative">
      <span v-if="prefixIcon" class="prefix-icon">
        <i :class="prefixIcon"></i>
      </span>
      <input :id="id" :type="type" class="form-control" :class="getClasses(size, color)" :name="name" :value="value"
        :placeholder="placeholder" :isRequired="isRequired" :disabled="disabled"
        @input="(e) => this.$emit('update:value', e.target.value)" />
      <span v-if="clearable && value" class="clear-icon" @click="handleClear">
        <i class="fas fa-times"></i> <!-- Assuming Font Awesome for the 'X' icon -->
      </span>
    </div>
  </div>
</template>

<script>
import setMaterialInput from "@/assets/js/material-input.js";

export default {
  name: "MaterialInput",
  props: {
    variant: {
      type: String,
      default: "outline",
    },
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "dark"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    prefixIcon: {
      type: String,
      default: ""
    }
  },

  emits: ['update:value', 'clear'],
  mounted() {
    setMaterialInput();
  },
  methods: {
    getClasses: (size) => {
      let sizeValue;

      sizeValue = size ? `form-control-${size}` : null;

      return sizeValue;
    },
    getStatus: (error, success) => {
      let isValidValue;

      if (success) {
        isValidValue = "is-valid";
      } else if (error) {
        isValidValue = "is-invalid";
      } else {
        isValidValue = null;
      }

      return isValidValue;
    },
    handleClear() {
      this.$emit('update:value', '');
      this.$emit('clear');
    }
  },
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
}

.prefix-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa; /* Adjust icon color as needed */
  z-index: 1;
  pointer-events: none; /* Allows clicks to pass through to input */
  width: 20px; /* Optional: Fixed width for consistent spacing */
  text-align: center;
}

.clear-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa; /* Adjust icon color as needed */
  cursor: pointer;
  z-index: 1;
}

.form-control {
  padding-left: 40px; /* Increased for icon space (adjust as needed) */
  padding-right: 30px; /* For clear icon */
}
</style>